const steps = [
  {
    n: "01",
    title: "Discovery Call",
    body:
      "45 minutes. We learn the AI feature, data flows, users, permissions, regulatory obligations, and rollout timeline. Written proposal within 48 hours.",
  },
  {
    n: "02",
    title: "Assessment",
    body:
      "We test the AI feature, application layer, data access patterns, prompts, retrieval paths, logging, and infrastructure touchpoints. Every finding is documented with severity, business impact, and remediation guidance.",
  },
  {
    n: "03",
    title: "Remediation",
    body:
      "We help fix what we find. Not just a report. Code-level, configuration, access control, privacy, and process fixes are prioritized and validated.",
  },
  {
    n: "04",
    title: "Safe Rollout",
    body:
      "With the critical risks closed and evidence assembled, your team can move forward with a safer launch, stronger enterprise readiness, and documented security posture.",
  },
];

export default function ArqHowItWorks() {
  return (
    <section id="how-it-works" className="bg-arq-surface1 py-20 md:py-[120px] px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center max-w-[820px] mx-auto mb-16">
          <div className="arq-label mb-6">Engagement Model</div>
          <h2 className="font-display font-semibold text-arq-text" style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}>
            From AI Feature Review to Validated Remediation.
          </h2>
        </div>

        {/* Desktop horizontal */}
        <div className="hidden md:block relative">
          <div className="absolute top-7 left-[12.5%] right-[12.5%] h-px bg-arq-border" />
          <div className="grid grid-cols-4 gap-8 relative">
            {steps.map((s) => (
              <div key={s.n} className="text-center">
                <div className="mx-auto w-14 h-14 rounded-full bg-arq-bg border border-arq-blue flex items-center justify-center mb-6 relative z-10">
                  <span className="font-mono-tech text-[14px] text-arq-blue">{s.n}</span>
                </div>
                <h3 className="font-display text-[20px] font-semibold text-arq-text mb-3">{s.title}</h3>
                <p className="text-arq-muted text-[15px] leading-[1.7]">{s.body}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile vertical */}
        <div className="md:hidden space-y-8 relative">
          {steps.map((s, i) => (
            <div key={s.n} className="flex gap-5">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-arq-bg border border-arq-blue flex items-center justify-center flex-shrink-0">
                  <span className="font-mono-tech text-[13px] text-arq-blue">{s.n}</span>
                </div>
                {i < steps.length - 1 && <div className="w-px flex-1 bg-arq-border mt-2" />}
              </div>
              <div className="flex-1 pb-2">
                <h3 className="font-display text-[18px] font-semibold text-arq-text mb-2">{s.title}</h3>
                <p className="text-arq-muted text-[15px] leading-[1.7]">{s.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
